import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook } from 'lucide-react';
export function Social() {
  return <section className="py-24 bg-white" data-id="element-246">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-247">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-248">
          Seguinos en redes
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-charcoal-light mb-10" data-id="element-249">
          Conocé más fotos, novedades y momentos compartidos en nuestras redes
          sociales.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex justify-center gap-6" data-id="element-250">
          <a href="https://www.instagram.com/cabanas_mirador/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-8 py-4 bg-sand-light text-charcoal rounded-full hover:bg-sand transition-colors font-medium" data-id="element-251">
            <Instagram size={24} className="text-earth" data-id="element-252" />
            Instagram
          </a>
          <a href="https://www.facebook.com/profile.php?id=100032458406811" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-8 py-4 bg-sand-light text-charcoal rounded-full hover:bg-sand transition-colors font-medium" data-id="element-253">
            <Facebook size={24} className="text-earth" data-id="element-254" />
            Facebook
          </a>
        </motion.div>
      </div>
    </section>;
}